import { error } from "console";
import { FormatReportDateTime } from "../../Logic/DateTimeFormatters";

export function formatDatePeriods(period: string): { startDate: string; endDate: string } {
    let startDate = FormatReportDateTime(new Date(), "00:00");
    let endDate = FormatReportDateTime(new Date(), "23:59");
    const today = new Date();
    var lastday = new Date();
    switch (period) {
        case "Today":
            startDate = FormatReportDateTime(new Date(), "00:00");
            endDate = FormatReportDateTime(new Date(), "23:59");
            break;
        case "This Week":
            var curr = new Date(); // get current date
            var first = curr.getDate() - curr.getDay(); // First day is the  day of the month - the day of the week
            var firstday = new Date(curr.setDate(first));
            var lastday = new Date(curr.setDate(curr.getDate() + 6));
            startDate = FormatReportDateTime(firstday, "00:00");
            endDate = FormatReportDateTime(lastday, "23:59");
            break;
        case "This Month":
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            startDate = FormatReportDateTime(firstDay, "00:00");
            endDate = FormatReportDateTime(lastDay, "23:59");
            break;
        case "Previous Day":
            const yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1);
            startDate = FormatReportDateTime(yesterday, "00:00");
            endDate = FormatReportDateTime(yesterday, "23:59");
            break;
        case "Previous Week":
            var firstDayCurrentWeek = today.getDate() - today.getDay();
            var firstdayOb = new Date(new Date().setDate(firstDayCurrentWeek - 7));
            const firstdayTemp = new Date(new Date().setDate(firstDayCurrentWeek - 7));
            lastday = new Date(firstdayTemp.setDate(firstdayTemp.getDate() + 6));
            startDate = FormatReportDateTime(firstdayOb, "00:00");
            endDate = FormatReportDateTime(lastday, "23:59");
            break;
        case "Previous Month":
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth(), 0);
            startDate = FormatReportDateTime(firstDay, "00:00");
            endDate = FormatReportDateTime(lastDay, "23:59");
            break;
    }
    return { startDate, endDate };
}

export function validateDateRange(youngerThan: number, startDate: Date, endDate: Date) {
    let errors: string[] = [];
    if (startDate > endDate) {
        errors.push("From Date cannot be later than To Date.");
    } else {
        let months = (endDate.getFullYear() - startDate.getFullYear()) * 12;
        months -= startDate.getMonth();
        months += endDate.getMonth();
        // Adjust for the day of the month: if the end date's day is less than the start date's day,
        // a full month has not passed yet, so subtract one month.
        if (endDate.getDate() < startDate.getDate()) {
            months--;
        }
        if (months > 12) {
            errors.push("Date range cannot be more than 12 months.");
        }
    }
    return errors;
}
